(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cn-promotion-countdown"] && !Shopify.designMode) return;
  try {
    const promoZone = 'America/Toronto';
  const promoDateParts = new Intl.DateTimeFormat('en-CA', {
    timeZone: promoZone, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  const promoDateLabel = new Intl.DateTimeFormat(document.documentElement.lang || 'en-CA', {
    timeZone: promoZone, year: 'numeric', month: 'short', day: 'numeric',
    hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
  });
  function promoPartsAt(value) {
    const parts = Object.fromEntries(promoDateParts.formatToParts(value).map(part => [part.type, part.value]));
    return Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
  }
  function promoTimestamp(date, time) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^\d{2}:\d{2}$/.test(time)) return NaN;
    const [year, month, day] = date.split('-').map(Number);
    const [hour, minute] = time.split(':').map(Number);
    if (year < 2000 || year > 9999 || hour > 23 || minute > 59) return NaN;
    const wall = Date.UTC(year, month - 1, day, hour, minute);
    const check = new Date(wall);
    if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) return NaN;
    let value = wall;
    for (let attempt = 0; attempt < 4; attempt++) {
      const adjustment = wall - promoPartsAt(value);
      if (adjustment === 0) return value;
      value += adjustment;
    }
    return NaN;
  }
  if (!customElements.get('cn-promotion-countdown')) {
    customElements.define('cn-promotion-countdown', class extends HTMLElement {
      static get observedAttributes() {
        return ['data-enabled', 'data-start-date', 'data-start-time', 'data-end-date', 'data-end-time'];
      }
      connectedCallback() {
        this.refresh = () => this.tick();
        document.addEventListener('visibilitychange', this.refresh);
        this.configure();
      }
      disconnectedCallback() {
        clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.refresh);
        this.querySelectorAll('.cn-promo-sheet-leaving').forEach(sheet => sheet.remove());
        if (this.heading) this.heading.hidden = true;
      }
      attributeChangedCallback() {
        if (this.isConnected && this.refresh) this.configure();
      }
      configure() {
        clearInterval(this.interval);
        this.clockReady = false;
        this.querySelectorAll('.cn-promo-sheet-leaving').forEach(sheet => sheet.remove());
        this.content = this.querySelector('[data-promo-content]');
        if (!this.content) return;
        this.heading = this.closest('.campaign-content')?.querySelector('[data-promo-heading]');
        this.end = promoTimestamp(this.dataset.endDate, this.dataset.endTime);
        this.start = this.dataset.startDate ? promoTimestamp(this.dataset.startDate, this.dataset.startTime) : -Infinity;
        this.valid = Number.isFinite(this.end) && (this.start === -Infinity || Number.isFinite(this.start)) && this.start < this.end;
        this.enabled = this.dataset.enabled === 'true';
        if (this.valid) {
          const deadline = this.querySelector('[data-promo-deadline]');
          deadline.dateTime = new Date(this.end).toISOString();
          deadline.textContent = promoDateLabel.format(this.end);
        }
        this.tick();
        if (this.valid && this.enabled && Date.now() < this.end) this.interval = setInterval(() => this.tick(), 1000);
      }
      tick() {
        const now = Date.now();
        const state = !this.enabled ? 'disabled' : !this.valid ? 'invalid' : now < this.start ? 'scheduled' : now >= this.end ? 'expired' : 'active';
        this.dataset.state = state;
        const active = state === 'active';
        this.hidden = !active && this.dataset.editor !== 'true';
        this.content.hidden = !active;
        if (this.heading) this.heading.hidden = !active;
        this.querySelectorAll('[data-promo-notice]').forEach(notice => { notice.hidden = notice.dataset.promoNotice !== state; });
        if (!active) {
          this.querySelectorAll('.cn-promo-sheet-leaving').forEach(sheet => sheet.remove());
          if (state !== 'scheduled') clearInterval(this.interval);
          return;
        }
        const total = Math.ceil((this.end - now) / 1000);
        const units = {days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60};
        this.querySelectorAll('[data-promo-unit]').forEach(element => {
          const value = String(units[element.dataset.promoUnit]).padStart(2, '0');
          if (element.textContent !== value) {
            const previous = element.textContent;
            element.textContent = value;
            if (this.clockReady && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
              element.parentElement.querySelector('.cn-promo-sheet-leaving')?.remove();
              const sheet = document.createElement('div');
              sheet.className = 'cn-promo-sheet-leaving';
              sheet.setAttribute('aria-hidden', 'true');
              sheet.textContent = previous;
              element.parentElement.append(sheet);
              sheet.addEventListener('animationend', () => sheet.remove(), {once: true});
            }
          }
        });
        this.clockReady = true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
